import { HealthcareProviderLocationIdentifier } from '@dreryk/egabinet-appointment-frontend-api';
import { ServiceLocationId, ServiceLocationType } from '@dreryk/egabinet-healthcare-provider-published-language-api';
import { Location } from '@dreryk/egabinet-waitlist-frontend-api';

export const isLocationIncompatible = (
   appointmentLocationIdentifier: HealthcareProviderLocationIdentifier | undefined,
   location: Location | undefined
): boolean => {
   if (!appointmentLocationIdentifier || !location) {
      return false;
   }
   return (
      ServiceLocationId.of(
         appointmentLocationIdentifier.type as ServiceLocationType,
         appointmentLocationIdentifier.locationId
      ).asString() !== location.id.asString()
   );
};
